import Hls from "hls.js"

import Hook from "../utils/hook"

export default Hook(`Hero`, {
  targets: [`video`],
  values: { videoActiveClass: String },
  actions: [
    {
      name: `videoCanPlay`,
      target: `video`,
      type: `canplaythrough`,
      once: true,
    },
  ],

  hls: null,

  mounted() {
    if (!this.videoTarget) return

    if (this.videoTarget.readyState >= 3) this.activateVideo()

    if (
      this.videoTarget.canPlayType(`application/vnd.apple.mpegurl`) !=
        `probably` &&
      Hls.isSupported()
    ) {
      this.hls = new Hls()
      this.hls.loadSource(this.videoTarget.src)
      this.hls.attachMedia(this.videoTarget)
    }
  },

  destroyed() {
    this.hls?.destroy()
  },

  videoCanPlayAction() {
    this.activateVideo()
  },

  activateVideo() {
    this.classAdd(this.videoActiveClassValue)
  },
})
